module.exports = __webpack_public_path__ + "img/love.f06b4a87.gif";